import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Conner } from '../constants/utilities';
// import Authenticate from '../components/Authenticate';
// import AddressList from "../components/AddressList";
// Only import the component necessary based on whether the user is validated or not
const Authenticate = lazy(() => import('../components/Authenticate'));
const AddressList = lazy(() => import("../components/AddressList"));



export default function Addresses() {
  const connerCookieName = process.env.REACT_APP_CONNER_COOKIE_NAME; 
  const [ validated, setValidated ] = useState(false);

  /*
    With the introduction of the API to access contact data, JWT
    technology was introduced to establish a validated session to
    be able to make calls to the API. The JWT currently has a timeout
    associated with it. Once the JWT times out, the user will be
    required to login again unless the session cookie is still 
    active.  If the session cookie is still active, a new JWT will
    be fetched silently.

    Once the browser is closed, the user will be required to 
    login again.

    This approach was determined to be the most secure given that
    the site operates under the http protocol and NOT https (in 
    order to save money on the certificate subscription).
  */

  useEffect(() => {
    // console.log("Cookie Name: " + connerCookieName);
    let isValidated = (Conner.getCookie(connerCookieName) === Conner.userValidatedCookieValue) ? true : false;
    // console.log(`validated = "${isValidated}"`)
    setValidated(isValidated);
  }, [connerCookieName]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      { (validated) ? <AddressList /> : <Authenticate setValidated={setValidated} /> }
    </Suspense>
  );
}


